import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFab from "./components/WhatsAppFab";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Trailers from "./pages/Trailers";
import WhyUs from "./pages/WhyUs";
import Contact from "./pages/Contact";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { err: false };
    }
    static getDerivedStateFromError() {
        return { err: true };
    }
    render() {
        if (this.state.err) {
            return (
                <div className="flex min-h-screen items-center justify-center p-8 text-center">
                    <div>
                        <p className="font-display text-2xl font-bold">Something went wrong.</p>
                        <p className="mt-2 text-sm text-steel">Please refresh the page.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => {
                if (window.__lenis) {
                    window.__lenis.scrollTo(hash, { offset: -90 });
                } else {
                    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
                }
            }, 450);
            return () => clearTimeout(t);
        }
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollManager />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/trailer-availability" element={<Trailers />} />
                        <Route path="/why-choose-us" element={<WhyUs />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <WhatsAppFab />
                <Toaster position="bottom-left" richColors />
            </BrowserRouter>
        </ErrorBoundary>
    );
}
